import React, { forwardRef } from 'react';
import { Stack } from '@contrast-security-inc/design-system-layouts';
import { Dropdown } from '../Dropdown';
import { IconButton } from '@contrast-security-inc/design-system-buttons';
import { IconArrowDown, IconArrowUp, theme, useLocalizationContext, } from '@contrast-security-inc/design-system-foundations';
import { determineItemValue, setupSafelyCallItemToID } from '../SelectModules/utils';
import * as messages from '../SelectModules/translations';
import { css, cx } from '@emotion/css';
export const SORT_DIRECTION = {
    ASCENDING: 'asc',
    DESCENDING: 'desc',
};
const dropdownStyles = css `
  padding-top: 0px;
  width: calc(100% - 24px); /* inherit from SortDropdown minus button */

  & fieldset {
    border-color: ${theme.color.neutral50};
  }

  button,
  && input,
  .ds-dropdown-input-value {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;
const isSortOptionWithInitialSortType = (option) => typeof option === 'object' && option && 'initialSortDirection' in option;
const SortDropdownInner = ({ sortDirection = SORT_DIRECTION.ASCENDING, options, sortOption, onSortChange, DropdownProps, className, testId, label, ...rest }, ref) => {
    const { formatMessage } = useLocalizationContext();
    const handleSortOptionChanged = (option) => {
        // Options do not have sort direction
        if (!option || !options.find((option) => isSortOptionWithInitialSortType(option))) {
            onSortChange({ sortDirection, sortOption: option });
        }
        else {
            // find the matching sort option
            const safelyCallItemToID = (option) => setupSafelyCallItemToID(DropdownProps?.itemToID, determineItemValue, option);
            const matchingOption = options.find((eachOption) => safelyCallItemToID(eachOption.option) === safelyCallItemToID(option));
            onSortChange({
                sortDirection: matchingOption?.initialSortDirection,
                sortOption: option,
            });
        }
    };
    const handleSortDirectionChanged = () => onSortChange({
        sortOption,
        sortDirection: sortDirection === SORT_DIRECTION.ASCENDING ? SORT_DIRECTION.DESCENDING : SORT_DIRECTION.ASCENDING,
    });
    return (React.createElement(Stack, { ...rest, spacing: "4px", ref: ref, className: cx('ds-sort-dropdown', className), testId: testId },
        React.createElement(IconButton, { "aria-label": sortDirection === SORT_DIRECTION.ASCENDING
                ? formatMessage(messages, 'ascending')
                : formatMessage(messages, 'descending'), testId: `${testId}-sort-direction-button`, variant: "primary", onClick: handleSortDirectionChanged, Icon: sortDirection === SORT_DIRECTION.ASCENDING ? IconArrowUp : IconArrowDown }),
        React.createElement(Dropdown, { ...DropdownProps, className: cx(DropdownProps?.className, dropdownStyles), label: label || formatMessage(messages, 'sortBy'), testId: `${testId}-sort-option-dropdown`, items: options.map((option) => isSortOptionWithInitialSortType(option) ? option.option : option), value: sortOption, onChange: (_evt, option) => handleSortOptionChanged(option) })));
};
SortDropdownInner.displayName = 'SortDropdown';
export const SortDropdown = forwardRef(SortDropdownInner);
